export default __webpack_public_path__ + "static/media/stargaragen_3.9f61bd24.jpg";